export default "__VITE_ASSET__D$yKXIKc__"